export const getLinkToZohoRecruitUserProfile = (id: string) => {
  return `https://recruit.zoho.com/recruit/org30986285/EntityInfo.do?module=Candidates&id=${id}&submodule=Candidates`;
};
